import axios from 'axios'

async function uploadCv(e) {
    var FormData = require('form-data');
    var data = new FormData();
    data.append('cv', e.target.files[0]);
    const token = localStorage.getItem('token');

    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/upload/biodata/cv`,
        data: data,
        headers: { token: token }
    };

    const res = await axios(config);
    return res
}
async function uploadIjazah(e) {
    var FormData = require('form-data');
    var data = new FormData();
    data.append('ijazah', e.target.files[0]);
    const token = localStorage.getItem('token');

    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/upload/biodata/ijazah`,
        data: data,
        headers: { token: token }
    };

    const res = await axios(config);
    return res
}
export { uploadCv, uploadIjazah };